import axios from "@/plugins/axios";

export default {
    getSupplies(data){
        return axios.get(`/api/console/shop/products/${data._product}/supplies`, data).then(result => result.data);
    },
    postSupply(data){
        return axios.post(`/api/console/shop/products/${data._product}/supplies`, data).then(result => result.data);
    },
    putSupply(data){
        return axios.put(`/api/console/shop/products/${data._product}/supplies/${data._id}`, data).then(result => result.data);
    },
    deleteSupply(data){
        return axios.delete(`/api/console/shop/products/${data._product}/supplies/${data._id}`).then(result => result.data);
    }
}
